module.exports = __webpack_public_path__ + "static/media/image2.dd7cee8a.svg";